import { useState } from 'react';

import { TSectionSelected } from '../Common/AssignResultsSectionSelector/AssignResultsSectionSelector';

type TUseResultsSectionSelector = () => [
  TSectionSelected,
  (section: TSectionSelected) => () => void
];

export const useResultsSectionSelector: TUseResultsSectionSelector = () => {
  const [sectionSelected, setSectionSelected] = useState<TSectionSelected>('Leaderboards');
  const onSetSection = (section: TSectionSelected) => () => setSectionSelected(section);

  return [sectionSelected, onSetSection];
};
